import React from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { useScreenSize } from '@/hooks';
import MenuContent from './MenuContent';
import styles from './Sidebar.module.css';

/**
 * Sidebar Component
 * Navigation sidebar with menu items
 * Follows JACKOPOT design system
 * Uses exact same SVG icons from old codebase
 */
const Sidebar = ({ isCollapsed, onToggle, onItemClick }) => {
  const { isMobile } = useScreenSize();
  const location = useLocation();

  if (isMobile) {
    return null; // Sidebar hidden on mobile, use bottom nav instead
  }

  // Handler to close sidebar when item is clicked
  const handleItemClick = () => {
    if (onItemClick) {
      onItemClick();
    }
  };

  return (
    <aside 
      className={`${styles.sidebar} ${isCollapsed ? styles.collapsed : ''}`}
    >
      <div className={styles.sidebarContent}>
        <MenuContent isCollapsed={isCollapsed} onItemClick={handleItemClick} />
      </div>
    </aside>
  );
};

export default Sidebar;
